<template>
    <div :class="{'c-split-btn':dropdown.length > 0}">
        <button type="button" class="c-btn c-btn--secondary c-btn--small c-btn--hollow no-margin" @click.prevent="mainbutton.action">
            {{mainbutton.label}}
        </button>
        <button v-if="dropdown.length > 0" class="c-btn c-btn--secondary c-btn--small c-btn--hollow no-margin" @click="active = !active" v-click-outside="closeSplitBtnDropdown">
            <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M12 10c1.104 0 2 .896 2 2s-.896 2-2 2-2-.896-2-2 .896-2 2-2Zm7 0c1.104 0 2 .896 2 2s-.896 2-2 2-2-.896-2-2 .896-2 2-2ZM5 10c1.104 0 2 .896 2 2s-.896 2-2 2-2-.896-2-2 .896-2 2-2Z" id="more"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#more"/></svg>
        </button>
        <div class="c-split-btn__dropdown" v-if="active && dropdown.length > 0">
            <ul class="c-list-dropdown">
                <li v-for="(button, index) in dropdown" :key="'dropdown-item-' + index"><a href="#" @click.prevent="button.action" class="fs-small">{{button.label}}</a></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        buttons: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            active: false
        }
    },
    computed: {
        mainbutton() {
            return this.buttons.slice(0,1)[0];
        },

        dropdown() {
            return this.buttons.slice(1);
        }
    },
    methods: {
        closeSplitBtnDropdown() {
            if (this.active === true) {
                this.active = false;
            }
        }
    }
}
</script>
